import React, { Fragment, useEffect, useState } from 'react';
import { useParams, useHistory, RouteComponentProps } from 'react-router-dom';
import * as api from "../../api";
import { useDispatch, useSelector } from 'react-redux';
import { Container } from "@material-ui/core";
import { saveDMCQuestions, saveDMCAnswers, removeAllDMCData, saveDuplicateDMCAnswers } from '../../ducks/redux/actions/FinancialReferral';
import { useTranslation } from 'react-i18next';
import ExitModalAndSave from '../Modal/ExitModalAndSave';
import Button from "../../Button/Button";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import classes from "../RepairUploadMedia/styles.module.css";
import styles from "../RepairUploadMedia/spinner.module.css";
import "./index.css";
import { detectMobile, getDMCSorCodeReference, getRepairPriority } from '../../utils/formatting';
import YellowAlert from '../YellowAlert';
import { userChosenEmergencyQuestion, userChosenSaveExit, userChosenVandalismQuestion, userChosenVulnerabilityQuestion, workOrderData, fromDampAndMouldAssesment1, fromDampAndMouldAssesment2, fromDampAndMouldAssesment3, userChosenDmcRepairLocation } from '../../ducks/redux/actions/userChoices';
import RepairJourney from '../RepairJourney';
import { repairPriorityRequest } from '../../models/Repair/RepairReason';
import { RepairChannel } from '../../models/Repair/RepairChannel';
import moment from 'moment';
import { CasePriority, RepairPriority, RepairPriorityCode } from '../../models/Repair/CreateRepair';
import { priorityCode, selectedRepairReasonDefaultPriority, selectedRepairReasonPriorityOverride } from '../../ducks/redux/actions/dashboardReducer.actions';
import { PermissionsList } from '../../models/Permissions';
import { workOrderRepairObject } from '../../ducks/redux/actions/getAddress';

interface DMCProps extends RouteComponentProps<any> { }

const DMCComponent: React.FC<DMCProps> = (props: any) => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = detectMobile();
  const [isLoading, setIsLoading] = useState(false);
  const [dmcQuestions, setDmcQuestions] = useState<any>();
  const [error, setError] = useState("");
  const history = useHistory();
  const workOrderObject = useSelector((state: any) => state.addresses?.workOrderRepair);
  const dmcAnswersFromReducer = useSelector((state: any) => state?.financialReferralReducer?.DMCAnsData);
  const assetByIdDataObject = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const vandalismConfigValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  const isRepairMedia = useSelector((state: any) => state?.userChoicesReducer?.isRepairMediaAllowed);
  let priorityCodeValue = useSelector((state: any) => state.dashboardReducer.formState?.priorityCode);
  let [currentQuestion, setCurrentQuestion] = useState(Number.parseInt(id) || 1);
  const configSOR = useSelector((state: any) => state?.financialReferralReducer?.sordamp);
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const selectedIsEmergencyVal = useSelector((state: any) => state?.userChoicesReducer?.selectedIsEmergencyValue);
  const [userAnswers, setUserAnswers] = useState<{ [key: string]: any }>({});
  const saveDuplicateDmcansData = useSelector((state: any) => state?.financialReferralReducer?.duplicatedmcansdata);
  const dmcInspectionSorCodes = useSelector((state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues);
  const customerDetails = useSelector((state: any) => state?.addresses?.saveCustomerDetails);
  const isAdditionalNeedsUser = useSelector((state: any) => state?.userChoicesReducer?.hasAdditionalNeeds);
  const supportedResident = useSelector((state: any) => state?.userChoicesReducer?.isSupportedResident);
  const selectedRepairReasonObject = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject);

  const roomCodeMapping: { [key: string]: string } = {
    '1': 'Bathroom',
    '2': 'Bedroom',
    '3': 'Kitchen',
    '4': 'Multiple Rooms',
    '5': 'Other room in your home',
  };


  const fetchDMCQuestionsData = async () => {
    try {
      const responseData = await api.getQuestionnaireMasterData()
      const keyValuePairs = responseData[0]?.namespace?.keyValues;
      for (const data of Object.entries(keyValuePairs)) {
        const [key, value] = data;
        if (value && (value as any).id === '46') {
          // storing DMC questions in state and redux
          setDmcQuestions(value)
          dispatch(saveDMCQuestions(value));
          setIsLoading(false)
        }
      }

    } catch (e) {
      console.log("Error occured!")
      setIsLoading(false)
      props.history.push("/GenericError");
    }
  }
  // Fetching previous ans and setting it to userAnswers
  useEffect(() => {
    if (saveDuplicateDmcansData) {
      setUserAnswers(saveDuplicateDmcansData);
    } else if (dmcAnswersFromReducer) {
      setUserAnswers(dmcAnswersFromReducer);
    }
  }, [dmcAnswersFromReducer]);

  //Call patch api and store selected ans for draft wo: To Do

  useEffect(() => {
    setIsLoading(true)
    fetchDMCQuestionsData()
  }, [])

  const navigateTo = (path: string) => {
    props.history.push(path);
  };

  const UpdateWorkOrder = (field: boolean) => {
    try {
      setIsLoading(true);
      workOrderObject.priority = priorityCodeValue; // set priority code value to work order object
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      saveAssessmentInformation();
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      )
    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    } finally {
      setIsLoading(false);
    }
  };

  const saveAssessmentInformation = () => {
    const assessmentInformation = {
      type: "DampAndMould",
      outcome: workOrderObject?.assessmentInformation?.outcome ?? null,
      communicationPreference: workOrderObject?.assessmentInformation?.communicationPreference ?? null,
      identifier: workOrderObject?.assessmentInformation?.identifier ?? null,
      supplementaryQuestionResponses: Object.entries(userAnswers).map(([questionId, answer]) => {
        const question = dmcQuestions?.additionalInfo.find((q: any) => q.questionId === questionId);
        if (question?.label === "Which room(s) are affected?") {
          const formattedAnswer = Array.isArray(answer)
            ? answer.map((code: string) => roomCodeMapping[code] || code).join(', ') // Map codes to room names
            : roomCodeMapping[answer] || answer; // Handle single answer
          dispatch(userChosenDmcRepairLocation(formattedAnswer));
        }

        return {
          questionId: questionId,
          questionLabel: question?.label || "",
          responseId: Array.isArray(answer) ? answer : [answer],
        };
      }),
      hasAdditionalNeeds: isAdditionalNeedsUser,
      isSupportedResident: supportedResident
    }
    workOrderObject.assessmentInformation = assessmentInformation;
  }

  const handleContinue = async () => {
    try {
      //getting number of questions page
      const lastPageGroupId = dmcQuestions?.additionalInfo
        ?.map((question: any) => Number.parseInt(question.pageGroupId))
        ?.reduce((max: number, current: number) => Math.max(max, current), 0);
      const unansweredQuestions = dmcQuestions?.additionalInfo
        ?.filter((question: any) => question.pageGroupId === currentQuestion.toString())
        ?.some((question: any) => {
          const answer = userAnswers[question.questionId];
          if (question.type === "List") {
            return !answer || answer === "" || answer === "Select";
          }
          if (question.type === "Multiple") {
            return !answer || answer.length === 0;
          }
          return !answer;
        });
      dispatch(saveDuplicateDMCAnswers(null));
      if (unansweredQuestions) {
        setError("Please answer all the questions to continue.")
      } else if (currentQuestion < lastPageGroupId && !unansweredQuestions) {
        setError("");
        setCurrentQuestion(currentQuestion + 1)
        dispatch(saveDMCAnswers(userAnswers));
        // Call wo patch and bind all selected labels and answers
        UpdateWorkOrder(false);
        history.push(`/DampAndMouldAssesment/${currentQuestion + 1}`);
      } else {
        saveAssessmentInformation();
        const dmcAssessmentPriorityValue = await api.assessmentScoreDetermination(workOrderObject?.assessmentInformation);
        if (dmcInspectionSorCodes?.includes(userChosenSOR)) {
          if (dmcAssessmentPriorityValue?.adjustedRiskRating !== CasePriority.High
            && selectedIsEmergencyVal !== 'Yes') {
            workOrderObject.isEmergency = false;
          }
          let repairPriorityPayload = new repairPriorityRequest();
          repairPriorityPayload = {
            isEmergency: workOrderObject?.isEmergency,
            repairType: userChosenSOR,
            description: workOrderObject?.description,
            channel: RepairChannel.ColleagueSelfServe,
            raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
            premisesType: assetByIdDataObject?.assetType,
            riskRating: dmcAssessmentPriorityValue?.adjustedRiskRating,
            assessmentType: workOrderObject?.assessmentInformation?.type,
            tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "",
            hasSeasonalPriority:selectedRepairReasonObject?.[0]?.hasSeasonalPriority ?? false
          }
          const dmcRepairPriority =
            (await api.repairPriorityDetermination(repairPriorityPayload))?.repairPriority;
          let repairPriority: any = await getRepairPriority(dmcRepairPriority);
          dispatch(priorityCode(dmcRepairPriority));
          dispatch(selectedRepairReasonPriorityOverride(repairPriority));
          dispatch(selectedRepairReasonDefaultPriority(repairPriority));
          let workorderChoosePriorityOfRepairPermission
            = getPermissionsData?.indexOf(PermissionsList.workorder_choose_priority_of_repair) >= 0;
          if (workorderChoosePriorityOfRepairPermission) {
            // Dispatch userChosenEmergencyQuestion from RepairReason ony for AR1
            let ar1EmergencySelectionValue = repairPriority === RepairPriority.Emergency ? "Yes" : "No";
            dispatch(userChosenEmergencyQuestion(ar1EmergencySelectionValue));
          }
          if (dmcRepairPriority === RepairPriorityCode.DampAndMouldEmergency) {
            workOrderObject.isEmergency = true;
          }
          priorityCodeValue = dmcRepairPriority;
        }
        if (workOrderObject?.isEmergency !== true) {
          const isVulnerable = Object.keys(userAnswers).includes("q7_1") && userAnswers["q7_1"]?.some((a: string) => ['2', '3', '4', '5'].includes(a));
          if (isVulnerable) {
            dispatch(userChosenVulnerabilityQuestion("Yes"));
          }
          else {
            dispatch(userChosenVulnerabilityQuestion("No"));
          }
        }
        const assessmentOutcomes = {
          adjustedRiskRating: dmcAssessmentPriorityValue?.adjustedRiskRating,
          totalScore: dmcAssessmentPriorityValue?.totalScore,
          riskRating: dmcAssessmentPriorityValue?.riskRating,
          vulnerabilityScore: dmcAssessmentPriorityValue?.vulnerabilityScore,
          vulnerabilityRiskRating: dmcAssessmentPriorityValue?.vulnerabilityRiskRating,
          communicationPreference: workOrderObject?.assessmentInformation?.communicationPreference ?? null
        };

        workOrderObject.assessmentInformation.outcome = assessmentOutcomes;
        dispatch(workOrderRepairObject(workOrderObject));
        dispatch(saveDMCAnswers(userAnswers));
        UpdateWorkOrder(false);
        dispatch(fromDampAndMouldAssesment1(false));
        dispatch(fromDampAndMouldAssesment2(false));
        dispatch(fromDampAndMouldAssesment3(false));
        if (isRepairMedia === "true") {
          navigateTo("/RepairUploadmedia");
        } else if (assetByIdDataObject?.statuses.isInDefects && vandalismConfigValue) {
          navigateTo("/VandalismQuestion");
        } else {
          dispatch(userChosenVandalismQuestion(""));
          navigateTo("/VulnerabilityQuestion");
        }
      }
    }
    catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    }
  };

  const backButtonHandler = () => {
    if (currentQuestion > 1) {
      dispatch(saveDuplicateDMCAnswers(null));
      setCurrentQuestion(currentQuestion - 1)
      history.push(`/DampAndMouldAssesment/${currentQuestion - 1}`);
    } else if (getDMCSorCodeReference(configSOR, userChosenSOR)) {
      props.history.push("/RepairAdditionalDetails");
    } else {
      props.history.push("/ConfirmedDampMould");
    }

  };
  const saveDraftAndExit = () => {
    // Updated save draft wo according to existing
    if (currentQuestion === 1) {
      dispatch(fromDampAndMouldAssesment1(true));
    } else if (currentQuestion === 2) {
      dispatch(fromDampAndMouldAssesment2(true));

    } else if (currentQuestion === 3) {
      dispatch(fromDampAndMouldAssesment3(true));
    }
    dispatch(userChosenSaveExit(true))
    dispatch(saveDuplicateDMCAnswers(userAnswers));
    UpdateWorkOrder(true);
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderData(worksOrder))
    props.history.push(
      `/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`
    );
  }

  const exitButtonHandler = () => {
    // removing all dmc answers when user changes the additional information
    dispatch(removeAllDMCData(null));
    props.history.push("/LandingView");
  }

  const dropDownHandler = (questionId: string, e: any) => {
    setUserAnswers((prevAnswers: any) => ({
      ...prevAnswers,
      [questionId]: e.target.value,
    }));
    setError("");
  }

  const handleCheckBox = (questionId: string, e: any) => {
    const selectedAnswers = userAnswers[questionId] || [];
    if (e.target.checked) {
      selectedAnswers.push(e.target.value);
    } else {
      const index = selectedAnswers.indexOf(e.target.value);
      if (index > -1) {
        selectedAnswers.splice(index, 1);
      }
    }
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: selectedAnswers,
    }));
    setError("");
  }

  const bindDMCQuestions = (id: number) => {
    return dmcQuestions?.additionalInfo
      ?.filter((question: any) => question.pageGroupId === (id).toString())
      ?.map((question: any) => (
        <div key={question.id}>
          <h2 className="text-purple-100">{question.label}</h2>
          <div className="mt-2">
            {question.type === 'List' ? (
              <select aria-label={question.questionId} key={question.questionId}
                onChange={(e) => dropDownHandler(question.questionId, e)}
                value={userAnswers[question.questionId] || ""} className='block dropDownWidth rounded border border-grey mb-4 bg-grey'>
                <option>Select</option>
                {question.options.map((option: any) => (

                  <option key={option.value} value={option.id}>
                    {option.value}
                  </option>
                ))}
              </select>
            ) : question.type === 'Multiple' ? (
              <div className={`grid ${(question.options.length > 4 && !isMobile) ? 'grid-cols-2' : 'grid-cols-1'}`}>
                {question.options.map((option: any) => (
                  <div key={option.value} className={`mb-1 ${isMobile ? 'flex w-full' : 'flex'}`}>
                    <fieldset>
                      <legend className="sr-only">{question.label}

                      </legend>
                      <input
                        type="checkbox"
                        id={`${question.questionId}-${option.id}`}
                        name={question.questionId}
                        className="checkPos"
                        value={option.id}
                        aria-label={option.value}
                        checked={userAnswers[question.questionId]?.includes(option.id) || false}
                        onChange={(e) => handleCheckBox(question.questionId, e)}
                      />
                    </fieldset>
                    <label
                      htmlFor={`${question.questionId}-${option.id}`}
                      className={`ml-4 ${isMobile ? 'inline-block mt-1 w-90' : ''}`}
                    >
                      {option.value}
                    </label>
                  </div>

                ))}
                <div className='mt-4'></div>
              </div>
            ) : null}
          </div>
        </div>
      ));
  }


  return (
    <Container id="supp-main-container" className="ctn-fht1 px-4" role="main">
      {isLoading ? (
        <div className={classes.overlay}>
          <div id="UploadingOverlay" data-testid="UpLoadingOverlay">
            <div className={styles.overlayContainer}>
              <div className={styles.overlayContent}>
                <div className={styles.spinner}></div>
              </div>
            </div>
          </div>
        </div>
      ) :
        (
          <Fragment>
            <div id="backmodal-div1" className="mx-auto mb-0" >
              <div className="back-and-journey">
                <p id="backmodal-p" className="text-teal text-xl mt-4 mb-4 md:mb-12">
                  <a className="back-btn" onClick={backButtonHandler} onKeyDown={backButtonHandler}>
                    <i className="fas fa-angle-left mr-2"></i>
                    {t("back")}
                  </a>
                </p>
                <div className=""></div>
                {<RepairJourney />}
              </div>
            </div>
            <div className="relative pb-2 bg-white" data-testid="dmc-assessment">
              {bindDMCQuestions(currentQuestion)}
            </div>
            {(error !== "") && <YellowAlert messageText={t(error)} {...props} />}
            <div
              id="custDetails-main-btn"
              className="flex justify-between items-center pb-4 md:pb-8"
            >
              <ExitModalAndSave
                id="custDetails-exitmodal"
                exit={exitButtonHandler}
                saveDraftAndExit={saveDraftAndExit}
              />
              <Button
                id="btn_custmerDetails"
                onClick={handleContinue}
                className="button-class"
              >
                Continue
                <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
              </Button>
            </div>
          </Fragment>
        )}
    </Container>
  );
};
export default DMCComponent;